import { IGif } from '@giphy/js-types'
import React, { PureComponent, SyntheticEvent } from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import FadeNextPrevious from 'shared/components/fade-next-previous'
import ScrollCarousel from 'shared/components/scroll-carousel'
import { relativeUrl } from 'shared/util/url'
import { tween } from 'shifty'
import styled from 'styled-components'
import { SectionHeaderWithSeeAll } from './section-header'

const SectionHeader = styled(SectionHeaderWithSeeAll)`
    margin-bottom: 6px;
`
type Props = {
    gifs: IGif[]
    width?: number
    height?: number
    title: string
    path: string
    scheduled?: boolean
    styles?: any
    isVideo?: boolean
    onClick?: Function
} & RouteComponentProps

type State = {
    scrollPosition: number
}

class ClickAndScrollCarousel extends PureComponent<Props, State> {
    state = {
        scrollPosition: 0,
    } as State
    savedRef: HTMLElement | null
    setScrollLeft = (position: number, original?: number) => {
        if (original !== undefined) {
            tween({
                from: { x: original },
                to: { x: position },
                duration: 700,
                easing: 'easeInOutQuart',
                step: state => this.setState({ scrollPosition: state.x }),
            })
        } else {
            this.setState({
                scrollPosition: position,
            })
        }
    }
    componentDidUpdate(_prevProps: Props, prevState: State) {
        const { scrollPosition } = this.state
        if (this.savedRef !== null && prevState.scrollPosition !== scrollPosition) {
            this.savedRef.scrollLeft = scrollPosition
        }
    }
    saveRef = (el: HTMLElement | null) => {
        this.savedRef = el
    }
    render() {
        const { gifs, width = 1040, height = 100, path, title, styles, isVideo, onClick, history } = this.props
        const { scrollPosition } = this.state
        return (
            <div style={styles}>
                <SectionHeader label={title} url={path} />
                <FadeNextPrevious
                    width={width}
                    height={height}
                    items={gifs}
                    setScrollLeft={this.setScrollLeft}
                    scrollLeft={scrollPosition}
                    isVideo={isVideo}
                >
                    <ScrollCarousel
                        gifs={gifs}
                        height={height}
                        onClick={
                            isVideo
                                ? undefined
                                : (e: SyntheticEvent<HTMLElement, Event>, gif: IGif) => {
                                      e.preventDefault()
                                      history.push(relativeUrl(gif.url))
                                      onClick?.(e, gif)
                                  }
                        }
                        onScroll={(e: SyntheticEvent<HTMLElement, Event>) =>
                            this.setScrollLeft(e.currentTarget.scrollLeft)
                        }
                        saveRef={this.saveRef}
                    />
                </FadeNextPrevious>
            </div>
        )
    }
}

export default withRouter(ClickAndScrollCarousel)
